(function (global){
'use strict';

var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null);

/**
 * @ngInject
 */
function SpinbuttonGroupController($document) {
  this.total = 0;
  var $scope;
  var $body = angular.element($document[0].body);
  // var $btnReserver = angular.element($document[0].getElementById('btn-reserver'));


  this.init = function(scope) {
    // si on est dans le tableau des logements, il faut prendre en compte le nombre de logements déjà sélectionnés
    if (angular.isDefined(scope.item) && angular.isDefined(scope.item.logement)) {
      var totalLogements = 0;
      angular.forEach(scope.item.logement, function(logement) {
        totalLogements += parseInt(logement.quantity, 10);
      });

      this.total = totalLogements;
    }

    $scope = scope;
    $scope.booking.limite = true;
    this.apply();
  };

  this.apply = function() {
    $scope.booking.total = this.total;

    if (this.total > 0) {
      $body.addClass('has-booking-bar');
    } else {
      $body.removeClass('has-booking-bar');
    }

  };

  this.moreRoom = function() {
    this.total++;
    this.apply();
  };

  this.lessRoom = function() {
    this.total--;
    this.apply();
  };

  this.showAlertMessage = function() {
      $scope.booking.limite = false;
      // $btnReserver.attr('disabled', 'disabled');
  };

  this.hideAlertMessage = function() {
      $scope.booking.limite = true;
      // $btnReserver.attr('disabled', false);
  };

}
SpinbuttonGroupController.$inject = ["$document"];

module.exports = SpinbuttonGroupController;
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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